// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-block {\n  display: flex;\n  align-items: center;\n}\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.logo img {\n  max-width: 49px;\n  width: 100%;\n  height: auto;\n}\n.logo-name {\n  margin-left: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  letter-spacing: -0.165px;\n  text-transform: uppercase;\n  color: #FFFFFF;\n}\n@media all and (max-width: 520px) {\n.logo-name {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
